import $ from 'jquery';
import Flickity from 'flickity';
class Slider {

	constructor(element) {
		$(document).ready(() => this.load());
	}

	load() {
		const imagerow = document.getElementsByClassName('twz-element-imagerow--slider');
		const promowithrating = document.getElementsByClassName('twz-element-promowithrating__slider');
		const reviewSlider = document.querySelectorAll('.twz-element-testimonial--slider');
		const slideOnMobile = document.querySelectorAll('.grid--slide_on_mobile');

		if (imagerow.length) {
			new Flickity( '.twz-element-imagerow--slider', {
				cellSelector: '.twz-element',
				cellAlign: 'center',
				contain: true,
				pageDots: false,
				adaptiveHeight: true,
			});

			const pageDots = document.querySelectorAll('.flickity-page-dot');
			if (pageDots) {
				for (let i = 0; i < pageDots.length; i++) {
					pageDots[i].textContent = "";
				}
			}
		}

		if (promowithrating.length) {
			new Flickity( '.twz-element-promowithrating__slider', {
				cellSelector: '.twz-element',
				cellAlign: 'left',
				contain: true,
				pageDots: false,
			});

			const pageDots = document.querySelectorAll('.flickity-page-dot');
			if (pageDots) {
				for (let i = 0; i < pageDots.length; i++) {
					pageDots[i].textContent = "";
				}
			}
		}

        if (reviewSlider ) {
            const Flickity = require('flickity');

			reviewSlider.forEach( reviewComponent => {
				if (reviewComponent.children.length > 3 || window.innerWidth < 1044 ) {
					console.log(window.innerWidth)

					new Flickity(reviewComponent, {
						cellAlign: 'left',
						prevNextButtons: false,
						pageDots: true,
						selectedAttraction: 0.1,
						friction: 0.65,
						draggable: true,
						autoPlay: 6000,
						contain: true,
						groupCells: true
					});
				}
			});

			const pageDots = document.querySelectorAll('.flickity-page-dot');
			if (pageDots) {
				for (let i = 0; i < pageDots.length; i++) {
					pageDots[i].textContent = "";
				}
			}
        }

		if (slideOnMobile) {
            const Flickity = require('flickity');
            Array.from(slideOnMobile).map(el => new Flickity(el, {
                cellAlign: 'center',
                prevNextButtons: true,
                pageDots: true,
                selectedAttraction: 0.1,
                friction: 0.65,
                draggable: true,
				watchCSS: true,
				contain: true
            }));

			const pageDots = document.querySelectorAll('.flickity-page-dot');
			if (pageDots) {
				for (let i = 0; i < pageDots.length; i++) {
					pageDots[i].textContent = "";
				}
			}
        }
	}
}

new Slider